module.exports = __webpack_public_path__ + "img/home-6.4263356f.png";